export const NAME = 'quotes';